import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaFormulaResponse } from '../../responses/repositorio-tintas/lista-formula.response';

@Injectable({
  providedIn: 'root',
})
export class FormulaService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public listaFormula(idFabricante: number, paginaAtual: number): Observable<ListaFormulaResponse> {
    const uri: string = `formula/listaFormula/idFabricante/${idFabricante}?paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaFormulaResponse>(environment.urlApiRepositorioTintas + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
